import type { ReactNode } from 'react';

export const symbol_file_save: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m700-238-53-53q-9-9-21-9t-21 9q-9 9-9 21t9 21l104 104q9 9 21 9t21-9l104-104q9-9 9-21t-9-21q-9-9-21-9t-21 9l-53 53v-151q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v151ZM610-60h240q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5Q880-17 871.38-8.5 862.75 0 850 0H610q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q597.25-60 610-60ZM220-160q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h281q12.44 0 23.72 5T544-862l198 198q8 8 13 19.28 5 11.28 5 23.72v112q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-111H545q-18.75 0-31.87-13.13Q500-646.25 500-665v-155H220v600h270q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H220Zm0-60v-600 600Z"
		/>
	</svg>
);
